module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "create-task-modal",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.editTask ? _vm.$t('calendar.tasks.edit_task') : _vm.$t('calendar.tasks.create_task')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#create-task-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "task-title"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.tasks.title")) + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask.title),
      expression: "newTask.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "task-title"
    },
    domProps: {
      "value": (_vm.newTask.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTask, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "task-description"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.tasks.description")) + "\n                  ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask.description),
      expression: "newTask.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "task-description",
      "cols": "30",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.newTask.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTask, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "task-notes"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("input.notes")) + "\n                  ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask.notes),
      expression: "newTask.notes"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "task-notes",
      "cols": "30",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.newTask.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTask, "notes", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "task-assigned-to"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.tasks.assigned_to")) + "\n                  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask.assigned_to),
      expression: "newTask.assigned_to"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "task-assigned-to"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newTask, "assigned_to", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Unassigned")]), _vm._v(" "), _vm._l((_vm.members), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(((member.first_name) + " " + (member.last_name))))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group form-material due-date"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "task-due-date"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.tasks.due_date")) + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('datepicker', {
    staticClass: "form-control",
    attrs: {
      "id": "task-due-date",
      "format": "dd D MMMM yyyy",
      "disabled-dates": _vm.disabledPastDates.disabled
    },
    model: {
      value: (_vm.newTask.due_date),
      callback: function($$v) {
        _vm.$set(_vm.newTask, "due_date", $$v)
      },
      expression: "newTask.due_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "task-rental"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.tasks.rental")) + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask.rental_id),
      expression: "newTask.rental_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "task-rental"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newTask, "rental_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.rentals), function(rental) {
    return _c('option', {
      domProps: {
        "value": rental.id
      }
    }, [_vm._v(_vm._s(rental.name))])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#create-task-modal')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("button.cancel")) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-save btn-red",
    attrs: {
      "type": "button",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editTask ? _vm.updateTask() : _vm.createTask()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editTask ? _vm.$t("button.update") : _vm.$t("button.create")) + "\n            ")]), _vm._v(" "), (_vm.editTask) ? _c('button', {
    staticClass: "btn waves-effect waves-classic btn-save btn-red",
    attrs: {
      "type": "button",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteTask()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("button.delete")) + "\n            ")]) : _vm._e()], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-395687c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/calendar/scheduler/task-management/CreateTask.vue
// module id = 1365
// module chunks = 0